module.exports = __webpack_public_path__ + "img/invitation_logo.7d73aca4.png";